import { Component, ElementRef, Input, OnInit, OnDestroy, ContentChild, TemplateRef, Output, EventEmitter } from '@angular/core';
import { DialogAnimation } from '../../_animation/dialog.animation';
import { DnDialogService } from './dn-dialog.service';

@Component({
  selector: 'dn-dialog',
  template:
    `
    <div [@dialog] *ngIf="visible" [ngStyle]=getDialogStyle() class="dialog {{ customClass }}"
      [ngClass]="{special: specialStyle === true, noPadding: noPadding === true}">
        <ng-content *ngTemplateOutlet="template; context: {data: values}"></ng-content>
    </div>
    <div *ngIf="visible" class="overlay" (click)="close()"></div>
      `,
  styleUrls: ['./dn-dialog.component.scss'],
  animations: [DialogAnimation]
})

export class DnDialogComponent implements OnInit, OnDestroy {

  @Output() onOpen:EventEmitter<any> = new EventEmitter<any>();
  @Input() id: string;
  @Input() size = {
    width: 400,
    height: 230,
  };
  @Input() closeable = true;
  visible;
  @Input()
  specialStyle = false;
  @Input()
  noPadding = false;

  // @Input()
  // parent = null;

  @Input()
  customClass = '';

  values: any;

  //private element: any;
  @ContentChild(TemplateRef, { read: TemplateRef, static: true }) template: TemplateRef<{ data: any }>;

  constructor(
    private dialogService: DnDialogService,
    // private el: ElementRef,
    // private _utility:Utility
  ) {
    // this.element = el.nativeElement;
  }

  ngOnInit(): void {
    // const dialog = this;

    if (!this.id) {
      console.error('dialog 必须包含 id');
      return;
    }

    // if (!parent) {
    //   this._utility.getDocument().body.appendChild(this.element);
    // } else {
    //   if ( this._utility.getDocument().getElementById(this.parent)) {
    //     this._utility.getDocument().getElementById(this.parent).appendChild(this.element);
    //   }
    // }

    // 点击背影可关闭
    // this.element.addEventListener('click', function (e: any) {
    //   if (e.target.className === 'dn-dialog-background open') {
    //     dialog.close();
    //   }
    // });
    this.dialogService.add(this);
  }

  ngOnDestroy(): void {
    this.dialogService.remove(this.id);

  }

  open(values): void {
    this.visible = true;
    this.values = values;
    // Object.keys(values).forEach( (key, index)=> {
    //   if ( this._utility.getDocument().getElementById(key)) {
    //     this._utility.getDocument().getElementById(key).innerHTML = values[key];
    //   }
    // });
    if (values != null && values["size"]) {
      this.orignalSize = this.size;
      this.size = values["size"];
    }

    this.onOpen.emit(values);
    // this.element.style.display = 'flex';
    // this.element.classList.add('open');
    // document.body.classList.add('dn-dialog-open');
  }
  private orignalSize = null;
  close(force = false): void {
    if (this.closeable || force)
      this.visible = false;
    if (this.orignalSize) {
      this.size = this.orignalSize;
    }
    // this.element.style.display = 'none';
    // this.element.classList.remove('open');
    // document.body.classList.remove('dn-dialog-open');
  }

  getDialogStyle() {
    return {
      'width': this.size.width + 'px',
      'height': this.size.height + 'px',
      'min-height': this.size.height + 'px',
    };
  }

}
